const roles = {
  ADMIN: 'ROLE_ADMIN',
  MANAGER: 'ROLE_MANAGER',
  USER: 'ROLE_USER',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/audio-station-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/screen-station-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/audio-editor\/send-to-station.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/audio-editor*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/screen-editor*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/files-device-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/report-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/administrator*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/administrator\/contractor-information.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/file-type.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/administrator\/user-activity-log.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    },
    {
      regex: /^\/residents-feedback-management\/managed-residents-feedback.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.MANAGER);
      }
    }
  ]
}
